<div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
  <div
    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
    [class]="data.destructive ? 'bg-error-container' : 'bg-primary-container'"
  >
    <mat-icon
      class="text-[20px]! w-5! h-5!"
      [class]="data.destructive ? 'text-on-error-container' : 'text-on-primary-container'"
      >{{ data.icon }}</mat-icon
    >
  </div>
  <div>
    <h2 class="text-lg font-medium leading-tight">{{ data.title }}</h2>
    @if (data.destructive) {
      <p class="text-sm text-on-surface-variant mt-0.5">Tato akce je nevratná</p>
    }
  </div>
</div>

<!-- Material zeroes the content's bottom padding when the dialog has actions. -->
<mat-dialog-content class="pb-5!">
  <p class="text-sm">
    {{ data.message }}
    @if (data.resourceName) {
      <span class="font-semibold">{{ data.resourceName }}</span
      >?
    }
    {{ data.messageAfter }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t border-outline-variant!">
  <button matButton (click)="dialogRef.close(false)">Zrušit</button>
  <button
    matButton="filled"
    [class]="data.destructive ? 'bg-error! text-on-error!' : ''"
    (click)="dialogRef.close(true)"
  >
    {{ data.confirmLabel }}
  </button>
</mat-dialog-actions>
